<template>
  <div>
    <v-select :multiple="true" :options="users" label="label" v-model="selectedValues"
              :disabled="!officeId || isProcessing" @change="onChange"/>
  </div>
</template>

<script>
import { ref, watch, defineComponent } from 'vue'
import api from '../libs/Api'
import Constants from '../constants'
import _ from 'underscore'

export default defineComponent({
  name: 'MultiSelectUser',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    officeId: {
      type: Number,
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  setup (props, { emit }) {
    const isProcessing = ref(false)
    const users = ref([])
    const selectedValues = ref([])

    watch(() => props.modelValue, (newValue) => {
      selectedValues.value = newValue
    })

    watch(() => props.officeId, () => {
      load()
    })

    const load = () => {
      users.value = []
      selectedValues.value = []

      if (!props.officeId) {
        return
      }

      isProcessing.value = true

      return api.getUser(Constants.QUERY_MODE_TRIM_GET, 1, props.officeId)
        .then(userList => {
          users.value = _.map(userList, user => {
            let label = user.display_name
            if (user.display_name_kana) {
              label = `${user.display_name}(${user.display_name_kana})`
            }
            return {
              id: user.id,
              label: label,
              display_name: user.display_name,
              display_name_kana: user.display_name_kana
            }
          })
        })
        .finally(() => {
          isProcessing.value = false
        })
    }

    const onChange = (event) => {
      emit('update:modelValue', selectedValues.value || [])
      emit('change', event)
    }

    // Initial load
    load()

    return {
      isProcessing,
      users,
      selectedValues,
      load,
      onChange
    }
  }
})
</script>

<style scoped>
</style>
